<template>
    <div class="consent-settings">
        <div class="consent-settings-head">
            Ustawienia plików cookies
        </div>
        <div
            v-bastards
            class="consent-settings-text">
            W zależności od funkcji i zastosowania pliki cookies możemy podzielić na cztery kategorie. Jeśli nie zostały
            wprowadzone żadne zmiany możesz przeglądać tę stronę korzystając z poniższych ustawień:
        </div>
        <div class="consent-settings-content">
            <div class="consent-settings-content-item">
                <Checkbox
                    :initial-value="true"
                    :disabled="true"
                    label="niezbędne"
                    name="necessary"
                    @checkboxToggle="(val) => toggleCheckbox(val, 'necessary')"
                />
                <div class="cookies-settings-content-item-info">
                    Te ciasteczka są niezbędne do używania strony internetowej jej podstawowych funkcjonalności dlatego
                    nie mogą zostać wyłączone.
                </div>
            </div>
            <div class="consent-settings-content-item">
                <Checkbox
                    :initial-value="true"
                    :is-required="false"
                    label="funkcjonalne"
                    name="functional"
                    @checkboxToggle="(val) => toggleCheckbox(val, 'functional')"
                />
                <div class="consent-settings-content-item-info">
                    Te ciasteczka pomagają przechowywać Twoje preferencje na temat treści, które chcesz otrzymywać w
                    prosty i łatwy sposób.
                </div>
            </div>
            <div class="consent-settings-content-item">
                <Checkbox
                    :initial-value="true"
                    :is-required="false"
                    label="wydajnościowe"
                    name="efficiency"
                    @checkboxToggle="(val) => toggleCheckbox(val, 'efficiency')"
                />
                <div class="consent-settings-content-item-info">
                    Te ciasteczka pomagają zaoszczędzić czas poprzez zwiększenie szybkości działania strony
                    internetowej.
                </div>
            </div>
            <div class="consent-settings-content-item">
                <Checkbox
                    :initial-value="true"
                    :is-required="false"
                    label="reklamowe"
                    name="advertising"
                    @checkboxToggle="(val) => toggleCheckbox(val, 'advertising')"
                />
                <div class="cookies-settings-content-item-info">
                    Te ciasteczka są niezbędne do oferowaniu Państwu promocji i ofert dopasowanych do Państwa potrzeb.
                </div>
            </div>
        </div>
        <div class="consent-settings-bottom">
            <div class="consent-settings-bottom-info">
                By dowiedzieć się więcej na temat ciasteczek i sposobu ich wykorzystania, sprawdź naszą
                <a
                    href="https://www.makro.pl/pliki-cookie"
                    target="_blank"
                    rel="noopener nofollow"
                    class="link-default"
                    title="Pliki cookie"
                >
                    politykę Cookies
                </a>
            </div>
            <div class="consent-settings-bottom-action">
                <button
                    :class="['btn btn-submit btn-submit--no-arrow', { 'is-dimmed': loading }]"
                    @click="onSave"
                    v-text="'Zapisz i kontynuuj'"
                />
                <Loader :is-active="loading" class="cookies-settings-bottom-action-loader" />
            </div>
        </div>
    </div>
</template>

<script>
import Checkbox from '@/components/input/Checkbox'
import ApiHub from '@/api/ApiHub'
import Loader from '@/components/loader/Loader'
import UuidMixin from '@/mixins/UuidMixin'
import { mapMutations } from 'vuex'

export default {
    mixins: [UuidMixin],
    components: {
        Checkbox,
        Loader
    },
    data() {
        return {
            necessary: true,
            functional: true,
            efficiency: true,
            advertising: true,
            loading: false
        }
    },
    computed: {
        cookiesTypes() {
            return {
                necessary: this.necessary,
                functional: this.functional,
                efficiency: this.efficiency,
                advertising: this.advertising
            }
        }
    },
    methods: {
        ...mapMutations([
            'setCookiesTypes'
        ]),
        toggleCheckbox(val, propertyName) {
            this[propertyName] = val
        },
        onSave() {
            this.loading = true
            let uuid = this.create_UUID()
            ApiHub.postCookieConsents(Object.assign({}, this.cookiesTypes, {
                sessionId: uuid,
                site: "Foodlovers"
            }))
                .then(() => {
                    this.setCookiesTypes(this.cookiesTypes)
                    window.localStorage.setItem(
                        'cookiesTypes',
                        JSON.stringify(this.cookiesTypes)
                    )
                    window.localStorage.setItem('cookiesAcceptedUuid', uuid)
                })
                .catch(e => {
                    console.log("Błąd zapisu zgód cookies")
                    console.log(e)
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/_variables/color';
@import 'src/assets/scss/_variables/screen';

.consent-settings {
    max-width: 1402px;
    padding: 24px 30px 19px;
    width: 100%;
    box-sizing: border-box;
    min-width: 1200px;

    &-head {
        color: $color-primary;
        font-size: 20px;
        line-height: 28px;
        font-weight: bold;
        margin-bottom: 30px;
    }

    &-text {
        font-size: 16px;
        line-height: 22px;
        color: $color-default;
        max-width: 894px;
        margin-bottom: 40px;
    }

    &-content {
        display: flex;

        &-item {
            max-width: 285px;
            margin-right: 45px;
            margin-bottom: 36px;

            &-info {
                font-size: 16px;
                line-height: 22px;
                margin-top: 18px;
            }
        }
    }

    &-bottom {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        &-info {
            font-size: 16px;
            line-height: 22px;
            max-width: 522px;

            .link-default {
                text-decoration: underline;
                color: $color-default;
                transition: color 0.2s;

                &:hover {
                    color: #989898;
                }
            }
        }

        &-action {
            position: relative;
            width: 100%;
            max-width: 256px;

            button {
                &.is-dimmed {
                    opacity: 0.1;
                    pointer-events: none;
                }
            }

            &-loader {
                position: absolute;
                top: 8px;
                left: calc(50% - 27px);
                transform-origin: 0 0;
            }
        }
    }

    @media (max-width: $screen-laptop-large) {
        min-width: 930px;
    }

    @media (max-width: 1024px) {
        min-width: 500px;
    }

    @media (max-width: 900px) {
        padding: 12px 15px 10px;

        &-head {
            margin-bottom: 15px;
            line-height: 20px;
        }

        &-text {
            font-size: 14px;
            line-height: 18px;
            margin-bottom: 20px;
        }

        &-content {
            flex-wrap: wrap;

            &-item {
                margin-right: 15px;
                margin-bottom: 20px;
                width: calc(50% - 16px);

                &-info {
                    font-size: 14px;
                    line-height: 17px;
                    margin-top: 16px;
                }

                .form-item-checkbox {
                    label {
                        font-size: 15px;
                        padding: 0 0 0 30px;
                    }
                }
            }
        }

        &-bottom {
            display: block;

            &-info {
                font-size: 14px;
                line-height: 17px;
                max-width: 100%;
                margin-bottom: 20px;
            }
        }
    }

    @media (max-width: 600px) {
        min-width: 300px;
    }

    @media (max-width: 500px) {
        &-content {
            &-item {
                width: 100%;
                margin-right: 0;
            }
        }
    }
}
</style>
